(function () {

  'use strict';
  angular
    .module('app')
    .config(['$stateProvider', '$urlRouterProvider', '$compileProvider', routeApp]);

    function routeApp ($stateProvider, $urlRouterProvider, $compileProvider) {

      //Initial state
      $stateProvider.state('building', {
        url: '/building/:uid/:name/:mode',
        templateUrl: 'templates/building.tpl.html',
        controller: 'buildingCtrl as vm',
        resolve: {
          data: function(serverCalls, $stateParams) {
            return serverCalls.getFanData({uid: $stateParams.uid, tplName: $stateParams.name});
          }
        }
      });

      // Default Url
      $urlRouterProvider.otherwise('/building');
    }
}());